import { render, staticRenderFns } from "./FreePassForm.vue?vue&type=template&id=5f15dc26&scoped=true"
import script from "./FreePassForm.vue?vue&type=script&lang=js"
export * from "./FreePassForm.vue?vue&type=script&lang=js"
import style0 from "./FreePassForm.vue?vue&type=style&index=0&id=5f15dc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15dc26",
  null
  
)

export default component.exports